import { gql } from '@apollo/client';

const COURSE_QUERY = gql`
    query course($courseID: UUID!) {
        course(courseID: $courseID) {
            node {
                id
                isPublished
                isIlt
                courseRevision {
                    revisionCount 
                    enrollmentCount
                }
                courseRevision {
                    revisionCount
                    learningObjects {
                        id
                        locales {
                            locale
                            name
                            description
                        }
                        sortOrder
                        isEnabled
                        duration
                        content {
                            id
                            url
                        }
                    }
                }
                courseCertificates {
                    id
                    courseId
                    certificateTemplate {
                        id
                        name
                    }
                    brand {
                        id
                        name
                        slug
                        segmentId
                        weight
                    }
                    createdAt
                    updatedAt
                  }
                locales {
                    locale
                    name
                    description
                }
                thumbnailImage {
                    id
                    name
                    url
                }
                heroImage {
                    id
                    name
                    url
                }
                tags
                tagIds
                points
                isPublic
                isSequential
                enrollmentCount
                learningObjects {
                    edges {
                        assignment {
                            status
                            scormState
                        }
                        node {
                            id
                            locales {
                                locale
                                name
                                description
                            }
                            sortOrder
                            isEnabled
                            duration
                            content {
                                id
                                url
                                instructorLedTrainingId
                            }
                        }
                    }
                }
                prerequisiteSet {
                    id
                    objectId
                    operator
                    type
                    prerequisites {
                        objectId
                        weight
                    }
                }
                prerequisiteStatus { 
                    isPrerequisiteOf
                    hasPrerequisites
                }
                isFeatured
                weight
                categoryIds
                segmentIds
                brandIds
                productIds
                localeIds
                learningProfileIds
                resourceIds
                companyRelationshipIds
                employeeLocaleIds
                metadata
                createdAt
                updatedAt
            }
        }
    }
`;

export default COURSE_QUERY;
